<!-- 企业级-业务领域-支付记录 -->
<template>
  <div class="mainArea CTPriceStrategy">
      
      <div class="searchDiv mt20">
        <div>
          <div class="dib"><el-input placeholder="请输入价格名称" v-model="keyword.name" clearable></el-input></div>
          <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
        </div>
      </div>
      <el-button type="primary" class="mb20 mt20" @click="openAdd">添加</el-button>
      <div class="tabList">
        <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="name" label="价格名称"></el-table-column>
          <el-table-column label="支付平台">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_way == '1'">微信</span>
              <span v-if="scope.row.pay_way == '2'">支付宝</span>
            </template>
          </el-table-column>
          <el-table-column label="计费方式">
            <template slot-scope="scope">
              <span v-if="scope.row.time_type == '0'">按次数</span>
              <span v-if="scope.row.time_type == '1'">按小时</span>
              <span v-if="scope.row.time_type == '2'">按天</span>
              <span v-if="scope.row.time_type == '3'">按月</span>
            </template>
          </el-table-column>
          <el-table-column label="费用">
            <template slot-scope="scope">
              <span>{{scope.row.amount | priceFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount_weekend" label="周末费用">
            <template slot-scope="scope">
              <span>{{scope.row.amount_weekend | priceFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column label="节假日费用">
            <template slot-scope="scope">
              <span>{{scope.row.amount_holiday | priceFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.$index)">修改</el-button>
              <el-button type="text" @click="openStatus(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging" v-if="total>page">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="page"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <el-dialog title="添加价格策略" :visible.sync="addPriceDio" width="800px">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="smzfform" label-width="90px">
            <el-form-item label="价格名称:" prop="tactics_name">
              <el-input v-model="smzfform.tactics_name" placeholder="如寄存柜支付开门等"></el-input>
            </el-form-item>
            <el-form-item label="支付平台:">
              <el-select v-model="smzfform.payPlat" placeholder="请选择支付平台">
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="计费方式:" prop="price">
              <div class="flex">
                <el-select v-model="smzfform.payMethod" placeholder="请选择计费方式">
                  <el-option label="按次数(单次)" value="0"></el-option>
                  <el-option label="按小时" value="1"></el-option>
                  <el-option label="按天" value="2"></el-option>
                  <el-option label="按月(30天)" value="3"></el-option>
                </el-select>
                <div class="ml20">
                  费用：<el-input v-model="smzfform.price" placeholder="请输入费用" class="w185"></el-input>
                  <template>元/{{smzfform.payMethod == '0' ? '次' : smzfform.payMethod == '1' ? '时' : smzfform.payMethod == '2' ? '天' : '月' }}</template>
                  <!-- <template v-if="smzfform.payMethod == '1'">元/小时</template><template v-else>元/次</template> -->
                </div>
                <div class="ml20">
                  <el-checkbox v-model="smzfform.setRentNum" v-if="smzfform.payMethod == '0'">允许选择租用次数</el-checkbox>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="周末费用:">
              <div class="flex week">
                <el-checkbox v-model="smzfform.weekend">单独设置周末费用</el-checkbox>
                <div class="ml20" v-if="smzfform.weekend == true">
                  费用：<el-input v-model="smzfform.weekPrice" placeholder="请输入费用" class="w185"></el-input>
                  <template>元/{{smzfform.payMethod == '0' ? '次' : smzfform.payMethod == '1' ? '时' : smzfform.payMethod == '2' ? '天' : '月' }}</template>
                  <!-- <template v-if="smzfform.payMethod == '1'">元/小时</template><template v-else>元/次</template> -->
                </div>
              </div>
            </el-form-item>
            <el-form-item label="节假日费用:">
              <div class="flex week">
                <el-checkbox v-model="smzfform.holiday">单独设置节假日费用</el-checkbox>
                <div class="ml20" v-if="smzfform.holiday == true">
                  费用：<el-input v-model="smzfform.holiPrice" placeholder="请输入费用" class="w185"></el-input>
                  <template>元/{{smzfform.payMethod == '0' ? '次' : smzfform.payMethod == '1' ? '时' : smzfform.payMethod == '2' ? '天' : '月' }}</template>
                  <!-- <template v-if="smzfform.payMethod == '1'">元/小时</template><template v-else>元/次</template> -->
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addPriceDio = false">取消</el-button>
          <el-button type="primary" @click="submitPrice('form')">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="修改价格策略" :visible.sync="editPriceDio" width="800px">
        <div class="contDio">
          <el-form ref="form2" :rules="rules" :model="editform" label-width="90px">
            <el-form-item label="价格名称:" prop="tactics_name">
              <el-input v-model="editform.tactics_name" placeholder="如寄存柜支付开门等"></el-input>
            </el-form-item>
            <el-form-item label="支付平台:">
              <el-select v-model="editform.payPlat" placeholder="请选择支付平台">
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="计费方式:" prop="price">
              <div class="flex">
                <el-select v-model="editform.payMethod" placeholder="请选择计费方式">
                  <el-option label="按次数(单次)" value="0"></el-option>
                  <el-option label="按小时" value="1"></el-option>
                  <el-option label="按天" value="2"></el-option>
                  <el-option label="按月(30天)" value="3"></el-option>
                </el-select>
                <div class="ml20">
                  费用：<el-input v-model="editform.price" placeholder="请输入费用" class="w185"></el-input>
                  <template>元/{{editform.payMethod == '0' ? '次' : editform.payMethod == '1' ? '时' : editform.payMethod == '2' ? '天' : '月' }}</template>
                  <!-- <template v-if="editform.payMethod == '1'">元/小时</template><template v-else>元/次</template> -->
                </div>
                <div class="ml20">
                  <el-checkbox v-model="editform.setRentNum" v-if="editform.payMethod == '0'">允许选择租用次数</el-checkbox>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="周末费用:">
              <div class="flex week">
                <el-checkbox v-model="editform.weekend">单独设置周末费用</el-checkbox>
                <div class="ml20" v-if="editform.weekend == true">
                  费用：<el-input v-model="editform.weekPrice" placeholder="请输入费用" class="w185"></el-input>
                  <template>元/{{editform.payMethod == '0' ? '次' : editform.payMethod == '1' ? '时' : editform.payMethod == '2' ? '天' : '月' }}</template>
                  <!-- <template v-if="editform.payMethod == '1'">元/小时</template><template v-else>元/次</template> -->
                </div>
              </div>
            </el-form-item>
            <el-form-item label="节假日费用:">
              <div class="flex week">
                <el-checkbox v-model="editform.holiday">单独设置节假日费用</el-checkbox>
                <div class="ml20" v-if="editform.holiday == true">
                  费用：<el-input v-model="editform.holiPrice" placeholder="请输入费用" class="w185"></el-input>
                  <template>元/{{editform.payMethod == '0' ? '次' : editform.payMethod == '1' ? '时' : editform.payMethod == '2' ? '天' : '月' }}</template>
                  <!-- <template v-if="editform.payMethod == '1'">元/小时</template><template v-else>元/次</template> -->
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editPriceDio = false">取消</el-button>
          <el-button type="primary" @click="editPrice('form2')">确定</el-button>
        </span>
      </el-dialog>
      <!--删除配置-->
      <el-dialog title="" :visible.sync="statusDio" class="statusDio">
        <div class="statusCont">
          <div>是否删除该价格策略？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="delConfig">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import { bussinessApi,userApi } from "../../../../static/js/api.js"

  export default {
    name: 'CTPriceStrategy',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          name:'',
        },
        configList:[],//价格策略列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        addPriceDio:false,//添加价格策略
        smzfform:{
          tactics_name:'',//价格名称
          payPlat:'1',//支付平台,1微信；2支付宝
          payMethod:'1',//计费方式；1按时间；2按次数
          price:'',//费用
          weekend:false,//周末费用
          weekPrice:'',
          holiday:false,//节假日费用
          holiPrice:'',
          setRentNum: false  // 设置租用次数
        },
        rules:{
          tactics_name:[
            { required: true, message: '请输入价格名称', trigger: 'blur' },
          ],
          price:[
            { required: true, message: '请输入费用', trigger: 'blur' },
          ],
        },

        editPriceDio:false,//修改价格策略
        editform:{
          tactics_id:'',//价格ID
          tactics_name:'',//价格名称
          payPlat:'1',//支付平台,1微信；2支付宝
          payMethod:'1',//计费方式；1按时间；2按次数
          price:'',//费用
          weekend:false,//周末费用
          weekPrice:'',
          holiday:false,//节假日费用
          holiPrice:'',
          setRentNum: false  // 设置租用次数
        },
        rules:{
          tactics_name:[
            { required: true, message: '请输入价格名称', trigger: 'blur' },
          ],
          price:[
            { required: true, message: '请输入费用', trigger: 'blur' },
          ],
        },

        statusDio:false,
        del_id:'',
      };
    },
    mounted(){

    },
    created: async function () {
      this.getWarehouse()
    },
    filters: {
      priceFilter: function (value) {
          return '￥'+value;
      },
    },
    methods: {
      //打开删除弹窗
      openStatus(index){
        this.del_id = this.configList[index].id
        this.statusDio = true;
      },
      //删除授权用户
      async delConfig(){
        let that = this;
        let data = {
          'id': that.del_id,//授权用户id
        }
        let res = await bussinessApi.delSmzfPrice(data)
        if (res.meta.code === 200) {
          that.getWarehouse(1)
          that.statusDio = false;
          showToast('删除成功！')
        } else {
          showToast(res.meta.message)
        }
      },

      //打开修改策略
      openEdit(index){
        let that = this
        this.editform = {
          tactics_id: that.configList[index].id,//价格id
          tactics_name: that.configList[index].name,//价格名称
          payPlat: that.configList[index].pay_way,//支付平台,1微信；2支付宝
          payMethod: that.configList[index].time_type,//计费方式；0（非时间） 1按小时 2 按天 3按月  (大范围：1按时间；2按次数)
          price:that.configList[index].amount,//费用
          weekend:that.configList[index].amount_weekend == '0.00' ? false : true,//周末费用
          weekPrice:that.configList[index].amount_weekend,
          holiday:that.configList[index].amount_holiday == '0.00' ? false : true,//节假日费用
          holiPrice:that.configList[index].amount_holiday,
          setRentNum: that.configList[index].is_choose_num == 1 ? true :false
        }
        this.editPriceDio = true;
      },
      //添加价格策略
      submitPrice(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitPrice2()
          } else { return false;}
        });
      },
      //添加价格策略
      editPrice(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitPrice2('2')
          } else { return false;}
        });
      },
      //添加和修改价格策略
      async submitPrice2(type){
        let that = this;
        if(type == 2){
          var data = {
            'id': that.editform.tactics_id,
            'name': that.editform.tactics_name,
            'pay_way': that.editform.payPlat,
            'pay_type': that.editform.payMethod == 0 ? 2 : 1,
            'time_type': that.editform.payMethod,
            'is_choose_num': that.editform.setRentNum && that.editform.payMethod == 0 ? 1 : 0,
            'amount': that.editform.price,
            'amount_weekend': that.editform.weekend == true ? that.editform.weekPrice : '',
            'amount_holiday': that.editform.holiday == true ? that.editform.holiPrice : '',
          }
        }else{
          var data = {
            'name': that.smzfform.tactics_name,
            'pay_way': that.smzfform.payPlat,
            'pay_type': that.smzfform.payMethod == 0 ? 2 : 1,
            'time_type': that.smzfform.payMethod,
            'is_choose_num': that.smzfform.setRentNum ? 1 : 0,
            'amount': that.smzfform.price,
            'amount_weekend': that.smzfform.weekend == true ? that.smzfform.weekPrice : '',
            'amount_holiday': that.smzfform.holiday == true ? that.smzfform.holiPrice : '',
          }
        }
        const res = await bussinessApi.updateTactics(data)
        if (res.meta.code === 200) {
          if(type == 2){
            that.editPriceDio = false
            that.getWarehouse()
          }else{
            that.smzfform.tactics_name=''
            that.smzfform.payPlat = ''
            that.smzfform.payMethod = ''
            that.smzfform.price = ''
            that.smzfform.weekend = false
            that.smzfform.holiday = false
            that.smzfform.weekPrice = ''
            that.smzfform.holiPrice = ''
            that.addPriceDio = false
            that.getWarehouse(1)
          }
        } else {
          showToast(res.meta.message)
        }
      },
      //打开添加弹窗
      openAdd(){
        this.addPriceDio = true;
      },
      //获取价格策略列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        var data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'name': that.keyword.name,//价格名称
        }
        let res = await bussinessApi.smzfPriceList(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CTPriceStrategy{
  .fs25{
    font-size:25px;
  }
  .w185{
    width: 185px;
  }
  .week{
    height: 40px;
    align-items: center;
  }
  .flexItem{
    flex-grow: 1;
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CTactics/CTPriceStrategy.vue